import { render, staticRenderFns } from "./AdminCouponGroupList.vue?vue&type=template&id=3ae567d8"
import script from "./AdminCouponGroupList.vue?vue&type=script&lang=js"
export * from "./AdminCouponGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports